import {
  EfsMelcoEfsModelsEfsDefaultFormat,
  ProductionFulfillmentApi,
  useAuthenticatedAPIConfig,
  useFormSubmit,
} from "melco-shared-logic";

export type BasicSettingsFormValueType = {
  enable_debug?: boolean;
  enable_folder_grouping?: boolean;
  embroidery_output_format?: string[];
  print_output_format?: string[];
  measurement_unit: string;
};

const transformOutputFormats = (
  values: BasicSettingsFormValueType
): EfsMelcoEfsModelsEfsDefaultFormat[] => {
  const outputFormatsValues = [
    ...(values.embroidery_output_format ?? []),
    ...(values.print_output_format ?? []),
  ];
  return outputFormatsValues.map((value) => ({
    extension: value,
  }));
};

export const useBasicSettingsFormSubmit = () => {
  const authenticatedApiConfig = useAuthenticatedAPIConfig();

  const onSubmit = useFormSubmit<BasicSettingsFormValueType>(
    async (values: BasicSettingsFormValueType, { resetForm }) => {
      const { enable_debug, enable_folder_grouping, measurement_unit } = values;

      const output_format = transformOutputFormats(values);
      const api = new ProductionFulfillmentApi(authenticatedApiConfig());
      await api.accountProductSettingsEditEfsUserSetting({
        efsMelcoEfsModelsCreateUserSetting: {
          enable_debug,
          enable_folder_grouping,
          output_format,
          measurement_unit,
        },
      });

      resetForm({ values });

      return { successMessages: [{ message: "default" }] };
    },
    { translationPrefix: "settings.basic" }
  );

  return onSubmit;
};
